import React from 'react'
import { Card, Accordion, Button, Form } from 'react-bootstrap'
import { OpenArrow, EditSeoIcon } from 'utils/svg'
import PropTypes from 'prop-types'

const HeadCode = ({ setIsHeadCode, isHeadCode, headCodeText, setHeadCodeText, isHeadCodeEditable, setHeadCodeEditable = () => { } }) => {

    const handleViewHeadCode = () => {
        setIsHeadCode(!isHeadCode)
        setHeadCodeEditable(false)
    }

    const updateHeadCode = () => {
        setHeadCodeText(headCodeText)
        setHeadCodeEditable(false)
    }

    return (
        <div className="head-code-section">
            <Accordion defaultActiveKey={ isHeadCode ? '0' : null }>
                <Card>
                    <Card.Header style={ { padding: 0 } }>
                        <Accordion.Toggle as={ Button } variant="link" eventKey="0" className='accordion-header'>
                            <Form className="header-form">
                                <Form.Check type="switch" checked={ isHeadCode } onChange={ handleViewHeadCode } id="head-code-switch" label="" />
                                <p>Head Code</p>
                            </Form>
                            <OpenArrow width={ 10 } height={ 7 } />
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {isHeadCode && <div className="content-wrapper">
                                <textarea
                                    value={ headCodeText }
                                    onChange={ (e) => setHeadCodeText(e.target.value) }
                                    disabled={ !isHeadCodeEditable }
                                />
                                <div className='head-code-btns'>
                                    {
                                        isHeadCodeEditable ?
                                            <button className='btn btn-primary' onClick={ updateHeadCode }> Save </button>
                                            :
                                            <button className="edit-btn btn btn-primary" onClick={ () => setHeadCodeEditable(true) }><EditSeoIcon />Edit</button>
                                    }
                                </div>
                            </div>}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </div>
    )
}

HeadCode.propTypes = {
    viewHeadCode: PropTypes.bool,
    setIsHeadCode: PropTypes.func,
    isHeadCode: PropTypes.bool,
    headCodeText: PropTypes.string,
    setHeadCodeText: PropTypes.func,
    isHeadCodeEditable: PropTypes.bool,
    setHeadCodeEditable: PropTypes.func
}

export default HeadCode